module.exports = __webpack_public_path__ + "static/media/rectangle-9.a253cf83.svg";